import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from '../firebase';import { createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, sendPasswordResetEmail, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { doc, setDoc, collection, getDocs, addDoc, query, where, getDoc } from "firebase/firestore";
import shopDefaultImage from '../assets/barbershop.jpeg'; 
import { translations } from './Translation';
import emailjs from '@emailjs/browser';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

function ChangeView({ center }) {
  const map = useMap();
  map.setView(center, map.getZoom());
  return null;
}

const parseDuration = (durStr) => {
  if (!durStr) return 30; 
  let mins = 0;
  const hMatch = durStr.match(/(\d+)\s*h/i);
  const mMatch = durStr.match(/(\d+)\s*m/i);
  if (hMatch) mins += parseInt(hMatch[1]) * 60;
  if (mMatch) mins += parseInt(mMatch[1]);
  return mins || 30;
};
const timeToMins = (timeStr) => { if (!timeStr) return 0; const [h, m] = timeStr.split(':').map(Number); return h * 60 + m; };
const minsToTime = (mins) => { const h = Math.floor(mins / 60).toString().padStart(2, '0'); const m = (mins % 60).toString().padStart(2, '0'); return `${h}:${m}`; };

function AnimatedNumber({ value, suffix = "", duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) { setIsVisible(true); observer.disconnect(); }
    });
    if (domRef.current) observer.observe(domRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      setCount(Math.floor(progress * value));
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  }, [isVisible, value, duration]);

  return <span ref={domRef}>{count.toLocaleString()}{suffix}</span>;
}

function Home({ onNavigate, user, darkMode, setDarkMode }) {
  const [language, setLanguage] = useState(localStorage.getItem('elitecut_lang') || 'en');
  const t = translations[language] || translations.en;

  useEffect(() => {
    const handleStorage = () => setLanguage(localStorage.getItem('elitecut_lang') || 'en');
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // --- NEW: FETCH SHOP DATA FOR THE HEADER ---
  const [shopData, setShopData] = useState(null);

  useEffect(() => {
    const fetchLiveShopName = async () => {
      // Only fetch if the user is logged in AND is a Partner/Owner
      if (user && user.uid && user.role === 'Partner') {
        try {
          const shopSnap = await getDoc(doc(db, "shops", user.uid));
          if (shopSnap.exists()) {
            setShopData(shopSnap.data());
          }
        } catch (error) {
          console.error("Error fetching live shop name:", error);
        }
      }
    };
    fetchLiveShopName();
  }, [user]);

  const [activeCategory, setActiveCategory] = useState('barbershop');
  const accentColor = activeCategory === 'hairsalon' ? '#ec4899' : '#f97316';
  const secondaryColor = activeCategory === 'hairsalon' ? '#db2777' : '#3b82f6';
  const gradientPrimary = activeCategory === 'hairsalon' ? 'linear-gradient(135deg, #f472b6, #be185d)' : 'linear-gradient(135deg, #6366f1, #a855f7)';
  const serviceFilters = activeCategory === 'hairsalon' ? ['Haircut', 'Coloring', 'Blowout', 'Styling'] : ['Haircut', 'Beard Trim', 'Fade', 'Color'];
  const pageBgLight = activeCategory === 'hairsalon' ? '#fdf2f8' : '#f8fafc';
  const pageBgDark = activeCategory === 'hairsalon' ? '#2e1025' : '#0f172a';

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [authMode, setAuthMode] = useState('login'); 
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [shopBarbers, setShopBarbers] = useState([]);
  const [isVerifyingCode, setIsVerifyingCode] = useState(false);
  const [shops, setShops] = useState([]);
  const [loadingShops, setLoadingShops] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRating, setSelectedRating] = useState(0);
  const [selectedService, setSelectedService] = useState('');
  const [selectedVibe, setSelectedVibe] = useState('');
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [citySearch, setCitySearch] = useState('');
  const [mapCenter, setMapCenter] = useState([41.3275, 19.8187]);
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setMapCenter([position.coords.latitude, position.coords.longitude]);
        },
        (error) => {
          console.warn("Geolocation blocked:", error.message);
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    }
  }, []);
  const [bookingShop, setBookingShop] = useState(null);
  const [bookingData, setBookingData] = useState({ barber: '', service: '', date: '', time: '' });
  const [availableSlots, setAvailableSlots] = useState([]);
  const [bookedIntervals, setBookedIntervals] = useState([]);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState('+355'); // Default to your country code (+355 for Albania, +39 for Italy)
  const [otp, setOtp] = useState('');
  const [confirmationResult, setConfirmationResult] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.15 });
    const hiddenElements = document.querySelectorAll('.reveal-section');
    hiddenElements.forEach((el) => observer.observe(el));
    return () => hiddenElements.forEach((el) => observer.unobserve(el));
  }, []);

  useEffect(() => {
    const fetchShops = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "shops"));
        setShops(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) { console.error(error); } 
      finally { setLoadingShops(false); }
    };
    fetchShops();
  }, []);

  useEffect(() => {
    const fetchBookings = async () => {
      if (!bookingData.date || !bookingData.barber || !bookingShop) return;
      const q = query(collection(db, "appointments"), where("shopId", "==", bookingShop.id), where("barberName", "==", bookingData.barber), where("date", "==", bookingData.date));
      const snapshot = await getDocs(q);
      const intervals = snapshot.docs.map(doc => {
        const data = doc.data();
        const startMins = timeToMins(data.time);
        return { start: startMins, end: startMins + parseDuration(data.duration) };
      });
      setBookedIntervals(intervals);
    };
    fetchBookings();
  }, [bookingData.date, bookingData.barber, bookingShop]);

  useEffect(() => {
    if (!bookingData.date || !bookingData.service || !bookingShop) return;
    const selectedBarber = bookingShop.barbers.find(b => b.name === bookingData.barber);
    const selectedService = selectedBarber?.services?.find(s => s.name === bookingData.service);
    if (!selectedService) return;

    const [year, month, day] = bookingData.date.split('-');
    const localDate = new Date(year, month - 1, day);

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const todaySchedule = bookingShop.schedule[days[localDate.getDay()]];
    if (!todaySchedule || todaySchedule.closed) { setAvailableSlots([]); return; }

    const serviceDuration = parseDuration(selectedService.duration);
    const openMins = timeToMins(todaySchedule.open);
    const closeMins = timeToMins(todaySchedule.close);
    
    const slots = [];
    let currentMins = openMins;
    while (currentMins + serviceDuration <= closeMins) {
      const proposedStart = currentMins;
      const proposedEnd = currentMins + serviceDuration;
      const hasOverlap = bookedIntervals.some(booking => (proposedStart < booking.end && proposedEnd > booking.start));
      if (!hasOverlap) slots.push(minsToTime(proposedStart));
      currentMins += 15; 
    }
    setAvailableSlots(slots);
  }, [bookingData.date, bookingData.service, bookingShop, bookedIntervals, bookingData.barber]);

  const verifyInviteCode = async (code) => {
    setInviteCode(code);
    if (code.length > 5) { 
      setIsVerifyingCode(true);
      try {
        const shopSnap = await getDoc(doc(db, "shops", code));
        if (shopSnap.exists()) setShopBarbers(shopSnap.data().barbers || []); 
        else setShopBarbers([]);
      } catch (e) { setShopBarbers([]); }
      setIsVerifyingCode(false);
    }
  };

  const sendVerificationCode = async (e) => {
    e.preventDefault();
    try {
      // 1. Create the invisible reCAPTCHA
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
          size: 'invisible'
        });
      }
      const appVerifier = window.recaptchaVerifier;

      // 2. Send the SMS
      const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
      setConfirmationResult(confirmation);
      alert("SMS sent! Please check your phone.");
    } catch (error) {
      console.error(error);
      alert("Error sending SMS. Ensure the number includes the country code (e.g., +39).");
    }
  };

  const verifyCodeAndRegister = async (e) => {
    e.preventDefault();
    try {
      // 1. Check if the code matches
      const result = await confirmationResult.confirm(otp);
      
      // 2. Create their account in Firestore
      await setDoc(doc(db, "users", result.user.uid), { 
        uid: result.user.uid, 
        name: fullName || "Client", 
        phoneNumber: phoneNumber,
        role: selectedRole || 'Client', 
        hasCompletedSetup: false, 
        createdAt: new Date() 
      });
      
      // 3. Close modal and navigate
      setIsLoginModalOpen(false);
      onNavigate('client-dashboard');
    } catch (error) {
      alert("Invalid code. Please try again.");
    }
  };

  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    try {
      if (authMode === 'register') {
        const cred = await createUserWithEmailAndPassword(auth, email.trim(), password);
        await setDoc(doc(db, "users", cred.user.uid), { uid: cred.user.uid, name: fullName, email: email.trim(), phone: phone, role: selectedRole, shopId: selectedRole === 'Staff' ? inviteCode : null, hasCompletedSetup: false, createdAt: new Date() });setIsLoginModalOpen(false);
        if (selectedRole === 'Partner') onNavigate('partner-setup');
        else if (selectedRole === 'Client') onNavigate('client-dashboard');
        else if (selectedRole === 'Staff') onNavigate('staff-dashboard');
      } else { 
        await signInWithEmailAndPassword(auth, email.trim(), password); 
        setIsLoginModalOpen(false); 
      }
    }catch (error) {
      // THE FIX: If they double-click the sign-up button, ignore the error
      if (error.code === 'auth/email-already-in-use') {
        alert("An account with this email already exists! Please switch to Sign In.");
        return; 
      }
      
      alert("Authentication Error: " + error.message);}
  };

const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      
      // Check if user exists in your database
      const userDoc = await getDoc(doc(db, "users", result.user.uid));
      
      if (!userDoc.exists()) {
        // If they are new, create their profile
        await setDoc(doc(db, "users", result.user.uid), {
          uid: result.user.uid,
          name: result.user.displayName,
          email: result.user.email,
          phone: phone,
          role: selectedRole || 'Client', // Default to what they selected, or Client
          createdAt: new Date()
        });
      }
      

      // Close modal and log them in
      setIsLoginModalOpen(false);
      
   } catch (error) {
      // THE FIX: Catch BOTH types of double-click and popup-closed errors
      if (error.code === 'auth/popup-closed-by-user' || error.code === 'auth/cancelled-popup-request') {
        console.log("Popup interrupted by user or double-click. Safely ignoring.");
        return; // This RETURN is crucial! It stops the code from reaching the alert below.
      }
      
      // Only show an alert if it is a real, serious error
      alert("Google Sign-In Error: " + error.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) return alert("Please enter your email address first.");
    try {
      await sendPasswordResetEmail(auth, email.trim());
      alert("Password reset email sent! Please check your inbox.");
    } catch (error) { alert("Error: " + error.message); }
  };

  const handleBookAppointment = async (e) => {
    e.preventDefault();
    if(!bookingData.barber || !bookingData.service || !bookingData.date || !bookingData.time) return alert("Please complete all selections.");
    
    try {
      // --- NEW ANTI-SPAM SHIELD ---
      // 1. Search the database for any active appointments belonging to this specific user
      const userBookingsQuery = query(
        collection(db, "appointments"), 
        where("clientId", "==", user.uid),
        where("status", "==", "active")
      );
      const userBookingsSnap = await getDocs(userBookingsQuery);
      
      // 2. If they already have 2 active bookings, block them from making a 3rd
      if (userBookingsSnap.docs.length >= 2) {
        return alert("Anti-Spam Protection: You already have 2 active appointments. Please complete or cancel them before booking another!");
      }
      // ----------------------------

      // If they passed the check, proceed with normal booking
      const selectedBarber = bookingShop.barbers.find(b => b.name === bookingData.barber);
      const selectedService = selectedBarber.services.find(s => s.name === bookingData.service);
      
      await addDoc(collection(db, "appointments"), { 
        clientId: user.uid, 
        clientName: user.name, 
        clientPhone: user.phone || 'No phone provided',
        shopId: bookingShop.id, 
        shopName: bookingShop.shopName, 
        barberName: selectedBarber.name, 
        serviceName: selectedService.name, 
        price: selectedService.price, 
        duration: selectedService.duration, 
        date: bookingData.date, 
        time: bookingData.time, 
        status: 'active', 
        createdAt: new Date() 
      });
      
      alert("Appointment Booked! A confirmation email has been sent to your inbox.");
      emailjs.send(
  'YOUR_SERVICE_ID',
  'YOUR_TEMPLATE_ID',
  {
    barber_email: selectedBarber.email, 
    client_name: user.name,
    client_phone: user.phone,
    service_name: selectedService.name,
    date: bookingData.date,
    time: bookingData.time
  },
  'YOUR_PUBLIC_KEY'
).then(() => {
  console.log("Notification email sent to barber!");
}).catch((error) => {
  console.error("Failed to send email alert:", error);
});
      setBookingShop(null);
      onNavigate('client-dashboard'); 
    } catch (error) { 
      alert("Error booking: " + error.message); 
    }
  };

  const renderStars = (rating) => '⭐'.repeat(Math.round(rating || 5));

const searchCityMap = async (e) => {
    e.preventDefault();
    if (!citySearch) return;
    try {
      // encodeURIComponent ensures spaces and characters don't break the URL string
      const safeSearch = encodeURIComponent(citySearch);
      
      // Added &countrycodes=it to restrict the search exclusively to Italy
      const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${safeSearch}&addressdetails=1&limit=1&countrycodes=it`);
      const data = await res.json();
      
      if (data && data.length > 0) {
        setMapCenter([parseFloat(data[0].lat), parseFloat(data[0].lon)]);
      } else {
        // Fallback alert so the user isn't clicking a button that does nothing
        alert("Location not found. Try adding the city name (e.g., 'Via Roma, Torino').");
      }
    } catch (err) { 
      console.error("Map search error:", err); 
    }
  };
  const filteredShops = shops.filter(shop => {
    const term = searchQuery.toLowerCase();
    const matchesSearch = shop.shopName?.toLowerCase().includes(term) || (shop.address || '').toLowerCase().includes(term);
    const matchesRating = (shop.rating || 5) >= selectedRating;
    const matchesService = selectedService ? shop.barbers?.some(b => b.services?.some(s => s.name.toLowerCase().includes(selectedService.toLowerCase()))) : true;
    const matchesVibe = selectedVibe ? shop.vibes?.includes(selectedVibe) : true;
    const matchesCategory = (shop.category || 'barbershop') === activeCategory;
    return matchesSearch && matchesRating && matchesService && matchesVibe && matchesCategory;
  });

  return (
    <>
      {loadingShops && (
        <div className="animated-gradient-hero" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 99999, borderRadius: 0, margin: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: gradientPrimary }}>
          <div style={{ background: 'white', width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px', marginBottom: '20px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
            {activeCategory === 'hairsalon' ? '💇‍♀️' : '⚡'}
          </div>
          <h1 style={{ fontSize: '42px', margin: '0 0 10px 0', letterSpacing: '-1px', color: 'white' }}>BookMyStyle</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', fontWeight: 'bold', letterSpacing: '4px', textTransform: 'uppercase' }}>
            Loading...
          </p>
        </div>
      )}

     <div className="home-page-premium" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: darkMode ? pageBgDark : pageBgLight, color: darkMode ? '#f8fafc' : '#0f172a', transition: 'background-color 0.5s ease' }}>
        <nav className="premium-navbar" style={{ background: darkMode ? '#1e293b' : 'white', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 40px', position: 'sticky', top: 0, zIndex: 100 }}>
          
          <div className="nav-brand" style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }} onClick={() => onNavigate('home')}>
            <div className="brand-logo-circle" style={{ background: gradientPrimary, boxShadow: `0 4px 12px ${activeCategory === 'hairsalon' ? 'rgba(236, 72, 153, 0.3)' : 'rgba(99, 102, 241, 0.3)'}`, transition: '0.3s' }}>
              <span style={{ fontSize: '22px' }}>{activeCategory === 'hairsalon' ? '✨' : '⚡'}</span>
            </div>
            <h1 style={{ fontSize: '22px', fontWeight: '800', margin: 0, letterSpacing: '-1px', color: darkMode ? 'white' : '#0f172a', textTransform: 'uppercase' }}>
              Book<span style={{ color: accentColor, transition: '0.3s' }}>MyStyle</span>
            </h1>
          </div>
          
          <div style={{ display: 'flex', background: darkMode ? '#0f172a' : '#f1f5f9', padding: '5px', borderRadius: '30px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
            <button 
              onClick={() => { setActiveCategory('barbershop'); setSelectedService(''); }}
              style={{ background: activeCategory === 'barbershop' ? 'white' : 'transparent', color: activeCategory === 'barbershop' ? '#0f172a' : '#64748b', boxShadow: activeCategory === 'barbershop' ? '0 2px 10px rgba(0,0,0,0.1)' : 'none', border: 'none', padding: '8px 24px', borderRadius: '25px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.3s ease', display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              💈 Barbershops
            </button>
            <button 
              onClick={() => { setActiveCategory('hairsalon'); setSelectedService(''); }}
              style={{ background: activeCategory === 'hairsalon' ? 'white' : 'transparent', color: activeCategory === 'hairsalon' ? '#0f172a' : '#64748b', boxShadow: activeCategory === 'hairsalon' ? '0 2px 10px rgba(0,0,0,0.1)' : 'none', border: 'none', padding: '8px 24px', borderRadius: '25px', fontWeight: 'bold', cursor: 'pointer', transition: 'all 0.3s ease', display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              💇‍♀️ Hair Salons
            </button>
          </div>

          <div className="nav-actions" style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
            {/* INSTAGRAM TOP LINK */}
            <a href="https://instagram.com/book_my_style101" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '5px', textDecoration: 'none', color: darkMode ? 'white' : '#0f172a', fontWeight: 'bold', fontSize: '14px', padding: '6px 12px', background: darkMode ? '#334155' : '#f1f5f9', borderRadius: '20px', transition: '0.2s' }}>
              📸 @book_my_stlyle101
            </a>
            
           <button 
              onClick={() => {
                // Cycle logic: English -> Albanian -> Italian -> English
                const nextLang = language === 'en' ? 'al' : language === 'al' ? 'it' : 'en';
                setLanguage(nextLang);
                localStorage.setItem('elitecut_lang', nextLang);
                window.dispatchEvent(new Event("storage"));
              }} 
              style={{ background: 'transparent', color: darkMode ? 'white' : '#0f172a', border: `1px solid ${darkMode ? '#334155' : '#cbd5e1'}`, borderRadius: '20px', padding: '6px 14px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px', transition: '0.2s' }}
            >
              🌐 {language === 'en' ? 'English' : language === 'al' ? 'Shqip' : 'Italiano'}
            </button>

            <button 
                onClick={() => onNavigate('how-it-works')} // This triggers your custom navigation engine
                style={{ background: 'transparent', color: darkMode ? 'white' : '#0f172a', border: 'none', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', padding: '6px 10px' }}>
                {t.howItWorksTop || "How it works"}
          </button>

            <button onClick={() => setDarkMode(!darkMode)} style={{ background: darkMode ? '#facc15' : '#e2e8f0', color: darkMode ? '#0f172a' : '#0f172a', border: 'none', width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.2s' }}>
              {darkMode ? '☀️' : '🌙'}
            </button>
            
            <button onClick={() => setIsMapModalOpen(true)} style={{ background: darkMode ? '#334155' : '#0f172a', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
              🗺️ Map View
            </button>
            <button onClick={() => onNavigate('social')} style={{ background: gradientPrimary, color: 'white', border: 'none', padding: '8px 15px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px', transition: '0.3s' }}>
              📱 Community
            </button>
            
            
            {user ? (
              <div style={{ position: 'relative', display: 'inline-block' }} onMouseEnter={() => setIsProfileDropdownOpen(true)} onMouseLeave={() => setIsProfileDropdownOpen(false)}>
                <div className="user-profile-avatar" onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)} style={{border: darkMode ? '2px solid #334155' : 'none', background: gradientPrimary}}>
                  {user.name ? user.name.charAt(0).toUpperCase() : '👤'}
                </div>
                {isProfileDropdownOpen && (
                  <div style={{ position: 'absolute', top: '100%', right: 0, paddingTop: '10px', width: '220px', zIndex: 1000 }}>
                    <div style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.15)', overflow: 'hidden' }}>
                      <div style={{ padding: '15px', borderBottom: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
                         <h4 style={{ margin: 0, fontSize: '15px', color: darkMode ? 'white' : '#0f172a' }}>{shopData?.shopName || user.name}</h4>
                          <p style={{ margin: 0, fontSize: '12px', color: '#64748b', textTransform: 'capitalize' }}>
                            {user.role === 'Client' ? t.clientAcc : (user.role === 'Partner' ? 'Owner Account' : user.role + ' Account')}
                          </p>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <button onClick={() => onNavigate(user.role === 'Partner' ? (user.hasCompletedSetup ? 'partner-dashboard' : 'partner-setup') : user.role === 'Staff' ? 'staff-dashboard' : 'client-dashboard')} style={{ padding: '12px 15px', background: 'transparent', border: 'none', color: darkMode ? '#cbd5e1' : '#334155', textAlign: 'left', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }} onMouseOver={(e) => { e.target.style.background = darkMode ? '#334155' : '#f1f5f9'; }} onMouseOut={(e) => { e.target.style.background = 'transparent'; }}>{t.goToDash}</button>
                        <button onClick={() => auth.signOut()} style={{ padding: '12px 15px', background: 'transparent', border: 'none', color: '#ef4444', textAlign: 'left', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }} onMouseOver={(e) => e.target.style.background = darkMode ? '#334155' : '#fef2f2'} onMouseOut={(e) => e.target.style.background = 'transparent'}>{t.logout}</button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <button className="premium-login-btn" style={{background: '#0f172a'}} onClick={() => setIsLoginModalOpen(true)}>Login</button>
            )}
          </div>
        </nav>

        <div className="home-content" style={{ flex: 1, display: 'flex', gap: '30px', padding: '40px 60px', width: '100%', boxSizing: 'border-box' }}>
         {/* 
          <aside style={{ width: '200px', flexShrink: 0, position: 'sticky', top: '100px', height: 'fit-content' }}>
            <div style={{ background: darkMode ? '#1e293b' : 'white', padding: '25px', borderRadius: '20px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', boxShadow: '0 4px 15px rgba(0,0,0,0.03)' }}>
              <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', color: darkMode ? 'white' : '#0f172a' }}>Filters</h3>
              <div style={{ marginBottom: '25px' }}>
                <h4 style={{ fontSize: '12px', color: '#64748b', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>Quick Services</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {serviceFilters.map(svc => (
                    <label key={svc} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: darkMode ? '#cbd5e1' : '#334155' }}>
                      <input type="radio" name="service" checked={selectedService === svc} onChange={() => setSelectedService(svc)} /> {svc}
                    </label>
                  ))}
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: darkMode ? '#cbd5e1' : '#334155' }}>
                      <input type="radio" name="service" checked={selectedService === ''} onChange={() => setSelectedService('')} /> All Services
                  </label>
                </div>
              </div>
              <div style={{ marginBottom: '10px' }}>
                <h4 style={{ fontSize: '12px', color: '#64748b', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>Minimum Rating</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {[5, 4, 3].map(stars => (
                    <label key={stars} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: darkMode ? '#cbd5e1' : '#334155' }}>
                      <input type="radio" name="rating" checked={selectedRating === stars} onChange={() => setSelectedRating(stars)} /> 
                      {stars} Stars & Up
                    </label>
                  ))}
                  <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer', color: darkMode ? '#cbd5e1' : '#334155' }}>
                      <input type="radio" name="rating" checked={selectedRating === 0} onChange={() => setSelectedRating(0)} /> Any Rating
                  </label>
                </div>
              </div>
            </div>
          </aside>
*/}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="hero-text-area">
              <h1 className="home-title" style={{color: darkMode ? 'white' : '#0f172a'}}>
                {activeCategory === 'hairsalon' ? t.welcomeSalons : t.welcomeBarbers}
              </h1>
              <div className="nav-search-pill" style={{maxWidth: '100%', margin: '20px 0', background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0'}}>
                <span className="search-icon">🔍</span>
                <input type="text" placeholder={activeCategory === 'hairsalon' ? t.searchSalons : t.searchBarbers} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{background: 'transparent', color: darkMode ? 'white' : '#0f172a', border: 'none', outline: 'none', width: '100%'}}/>
              </div>
            </div>
            
            {!loadingShops && filteredShops.length > 0 && (
              <div style={{ marginBottom: '40px' }}>
                <h3 style={{ margin: '0 0 15px 0', fontSize: '20px', color: darkMode ? '#cbd5e1' : '#475569' }}>{t.trending}</h3>
                <div style={{ display: 'flex', gap: '20px', overflowX: 'auto', paddingBottom: '20px', scrollbarWidth: 'none' }}>
                  {[...filteredShops].sort((a, b) => (b.rating || 0) - (a.rating || 0)).slice(0, 3).map(shop => (
                    <div key={`trend-${shop.id}`} onClick={() => onNavigate('detail', shop)} style={{ minWidth: '320px', height: '200px', borderRadius: '20px', cursor: 'pointer', position: 'relative', overflow: 'hidden', flexShrink: 0, boxShadow: darkMode ? '0 10px 20px rgba(0,0,0,0.4)' : '0 10px 20px rgba(0,0,0,0.1)', transition: '0.2s' }}>
                      <img src={shop.shopImage || shopDefaultImage} alt={shop.shopName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(to top, rgba(15,23,42,0.95), rgba(15,23,42,0.1))', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <h4 style={{ margin: 0, fontSize: '20px', color: 'white', fontWeight: 'bold' }}>{shop.shopName}</h4>
                          <span style={{ background: '#facc15', color: '#0f172a', padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>{t.topRated}</span>
                        </div>
                        <p style={{ margin: '0 0 10px 0', fontSize: '13px', color: '#cbd5e1' }}>📍 {shop.address?.substring(0, 35) || t.locationTBD}</p>
                        <div style={{ color: '#facc15', fontSize: '14px' }}>{renderStars(shop.rating)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="premium-venues-grid">
              {filteredShops.length === 0 ? (
                <p style={{color: '#64748b'}}>{t.noShops}</p>
              ) : (
                filteredShops.map(shop => (
                  <div key={shop.id} className="premium-venue-card" onClick={() => onNavigate('detail', shop)} style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
                    <div className="card-image-wrapper"><img src={shop.shopImage || shopDefaultImage} alt={shop.shopName} className="venue-image" /></div>
                    <div className="card-info">
                      <div className="card-header">
                        <h3 style={{color: darkMode ? 'white' : '#0f172a'}}>{shop.shopName}</h3>
                        <div className="rating-block"><span className="stars">{renderStars(shop.rating)}</span></div>
                      </div>
                      <p className="location-text" style={{color: darkMode ? '#94a3b8' : '#64748b'}}>📍 {shop.address || shop.location || t.locationTBD}</p>
                      <p className="location-text" style={{color: darkMode ? '#94a3b8' : '#64748b', marginTop: '4px'}}>📞 {shop.phone || 'Phone not available'}</p>
                      <div className="card-footer" style={{marginTop: '15px'}}>
                        <button className="premium-book-btn" style={{width: '100%', background: darkMode ? secondaryColor : '#0f172a'}} onClick={(e) => { e.stopPropagation(); if(!user){setIsLoginModalOpen(true)}else{setBookingShop(shop) }}}>{t.bookNow}</button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div> 
        </div>

        <div style={{ maxWidth: '1200px', margin: '80px auto 60px auto', padding: '0 40px', boxSizing: 'border-box' }}>
          <div className="reveal-section" style={{ textAlign: 'center', marginBottom: '80px' }}>
            <p style={{ fontSize: '12px', fontWeight: 'bold', color: accentColor, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '10px' }}>{t.howItWorksTop}</p>
            <h2 style={{ fontSize: '36px', margin: '0 0 40px 0', color: darkMode ? 'white' : '#0f172a' }}>{t.howItWorksTitle}</h2>
            
            <div className="how-it-works-grid">
              <div className="step-card" style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', color: darkMode ? 'white' : '#0f172a' }}>
                <span className="step-number" style={{ color: darkMode ? 'white' : '#0f172a' }}>01</span>
                <div style={{ fontSize: '28px', color: accentColor, marginBottom: '15px' }}>🔍</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>{t.step1Title}</h3>
                <p style={{ color: darkMode ? '#94a3b8' : '#64748b', fontSize: '14px', lineHeight: '1.6' }}>{t.step1Desc}</p>
              </div>
              <div className="step-card" style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', color: darkMode ? 'white' : '#0f172a' }}>
                <span className="step-number" style={{ color: darkMode ? 'white' : '#0f172a' }}>02</span>
                <div style={{ fontSize: '28px', color: accentColor, marginBottom: '15px' }}>📅</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>{t.step2Title}</h3>
                <p style={{ color: darkMode ? '#94a3b8' : '#64748b', fontSize: '14px', lineHeight: '1.6' }}>{t.step2Desc}</p>
              </div>
              <div className="step-card" style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', color: darkMode ? 'white' : '#0f172a' }}>
                <span className="step-number" style={{ color: darkMode ? 'white' : '#0f172a' }}>03</span>
                <div style={{ fontSize: '28px', color: accentColor, marginBottom: '15px' }}>✨</div>
                <h3 style={{ fontSize: '20px', marginBottom: '10px' }}>{t.step3Title}</h3>
                <p style={{ color: darkMode ? '#94a3b8' : '#64748b', fontSize: '14px', lineHeight: '1.6' }}>{t.step3Desc}</p>
              </div>
            </div>
          </div>

          <div className="reveal-section stats-banner" style={{ borderTop: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
            <div className="stat-item"><h3 style={{ color: accentColor }}><AnimatedNumber value={1200} suffix="+" /></h3><p style={{ color: darkMode ? '#94a3b8' : '#64748b' }}>{t.stats1}</p></div>
            <div className="stat-item"><h3 style={{ color: accentColor }}><AnimatedNumber value={84000} suffix="+" /></h3><p style={{ color: darkMode ? '#94a3b8' : '#64748b' }}>{t.stats2}</p></div>
            <div className="stat-item"><h3 style={{ color: accentColor }}><AnimatedNumber value={80} /></h3><p style={{ color: darkMode ? '#94a3b8' : '#64748b' }}>{t.stats3}</p></div>
          </div>

          <div className="reveal-section" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '50px', marginTop: '80px', paddingTop: '80px', borderTop: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <p style={{ fontSize: '12px', fontWeight: 'bold', color: accentColor, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '15px' }}>{t.forProsSubtitle}</p>
              <h2 style={{ fontSize: '42px', margin: '0 0 20px 0', color: darkMode ? 'white' : '#0f172a', lineHeight: '1.1', fontFamily: 'serif' }}>{t.forProsTitle}</h2>
              <p style={{ color: darkMode ? '#94a3b8' : '#64748b', fontSize: '16px', lineHeight: '1.6', marginBottom: '35px' }}>{t.forProsDesc}</p>
              <div>
                <button onClick={() => { setIsLoginModalOpen(true); setSelectedRole('Partner'); }} style={{ background: accentColor, color: 'white', border: 'none', padding: '15px 30px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', borderRadius: '8px', transition: '0.2s', letterSpacing: '1px' }}>
                  {t.listShopBtn}
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', padding: '25px', borderRadius: '12px', display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                <div style={{ fontSize: '24px', color: accentColor }}>✂️</div>
                <div><h3 style={{ margin: '0 0 5px 0', fontSize: '18px', color: darkMode ? 'white' : '#0f172a' }}>{t.profRules}</h3><p style={{ margin: 0, fontSize: '14px', color: darkMode ? '#94a3b8' : '#64748b' }}>{t.profRulesDesc}</p></div>
              </div>
              <div style={{ background: darkMode ? '#1e293b' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0', padding: '25px', borderRadius: '12px', display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                <div style={{ fontSize: '24px', color: accentColor }}>📸</div>
                <div><h3 style={{ margin: '0 0 5px 0', fontSize: '18px', color: darkMode ? 'white' : '#0f172a' }}>{t.lookbook}</h3><p style={{ margin: 0, fontSize: '14px', color: darkMode ? '#94a3b8' : '#64748b' }}>{t.lookbookDesc}</p></div>
              </div>
            </div>
          </div>
        </div>

        {/* MAP MODAL */}
        {/* MAP MODAL */}
        {isMapModalOpen && (
          <div className="login-modal-overlay" onClick={() => setIsMapModalOpen(false)}>
            <div className="login-modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '900px', height: '80vh', display: 'flex', flexDirection: 'column', background: darkMode ? '#1e293b' : 'white', position: 'relative' }}>
              
              <button className="modal-close-btn" onClick={() => setIsMapModalOpen(false)} style={{color: darkMode ? 'white' : 'black', zIndex: 10}}>✕</button>
              
              {/* --- UPDATED HEADER --- */}
              <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '15px', marginTop: '25px' }}>
                <form onSubmit={searchCityMap} style={{ display: 'flex', gap: '8px', width: '100%', paddingRight: '15px' }}>
                  <input 
                    type="text" 
                    placeholder="Search City..." 
                    value={citySearch} 
                    onChange={(e) => setCitySearch(e.target.value)} 
                    style={{ flex: 1, padding: '10px 12px', borderRadius: '8px', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1', background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', outline: 'none' }} 
                  />
                  <button type="submit" className="premium-login-btn" style={{ background: accentColor, margin: 0, padding: '10px 20px' }}>
                    Go
                  </button>
                </form>
              </div>
              {/* --- END UPDATED HEADER --- */}

              <div style={{ flex: 1, borderRadius: '16px', overflow: 'hidden', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
               <MapContainer key={`${mapCenter[0]}-${mapCenter[1]}`} center={mapCenter} zoom={13} style={{ width: '100%', height: '100%' }}>
                  <ChangeView center={mapCenter} />
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  {shops.map(shop => shop.lat && shop.lng ? (
                    <Marker key={shop.id} position={[Number(shop.lat), Number(shop.lng)]}>
                      <Popup>
                        <div style={{ textAlign: 'center' }}>
                          <h3 style={{ margin: '0 0 5px 0', color: 'black' }}>{shop.shopName}</h3>
                          <p style={{ margin: '0 0 10px 0', fontSize: '12px' }}>{renderStars(shop.rating)}</p>
                          <button className="premium-login-btn" style={{ padding: '5px 10px', fontSize: '12px' }} onClick={() => { setIsMapModalOpen(false); onNavigate('detail', shop); }}>View Profile</button>
                        </div>
                      </Popup>
                    </Marker>
                  ) : null)}
                </MapContainer>
              </div>
            </div>
          </div>
        )}

        {/* BOOKING MODAL */}
        {bookingShop && (
          <div className="login-modal-overlay" onClick={() => setBookingShop(null)}>
            <div className="login-modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '650px', maxHeight: '90vh', overflowY: 'auto', background: darkMode ? '#1e293b' : 'white'}}>
              <button className="modal-close-btn" onClick={() => setBookingShop(null)} style={{color: darkMode ? 'white' : 'black'}}>✕</button>
              <div className="form-header" style={{ marginBottom: '20px' }}>
                <h2 style={{color: darkMode ? 'white' : '#0f172a'}}>Book at {bookingShop.shopName}</h2>
                <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>Select a professional and service to view availability.</p>
              </div>
              
              <form className="auth-form" onSubmit={handleBookAppointment}>
                <div style={{ marginBottom: '25px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '10px', color: darkMode ? 'white' : '#0f172a' }}>1. Choose a Professional</label>
                  <div style={{ display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px' }}>
                    {bookingShop.barbers?.map(b => (
                      <div key={b.id} onClick={() => setBookingData({ ...bookingData, barber: b.name, service: '', time: '' })} style={{ minWidth: '130px', padding: '15px 10px', textAlign: 'center', cursor: 'pointer', borderRadius: '16px', border: bookingData.barber === b.name ? `2px solid ${secondaryColor}` : (darkMode ? '1px solid #334155' : '1px solid #e2e8f0'), background: bookingData.barber === b.name ? (darkMode ? '#0f172a' : (activeCategory === 'hairsalon' ? '#fdf2f8' : '#f8fafc')) : (darkMode ? '#1e293b' : 'white'), position: 'relative' }}>
                        {b.story && <div style={{ position: 'absolute', top: '-10px', right: '-10px', background: accentColor, color: 'white', fontSize: '11px', padding: '4px 8px', borderRadius: '12px', fontWeight: 'bold', animation: 'pulse 2s infinite', zIndex: 10 }}>New Story</div>}
                        {b.image ? <img src={b.image} alt={b.name} style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto 10px auto', display: 'block', border: b.story ? `3px solid ${accentColor}` : 'none' }} /> : <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: darkMode ? '#334155' : '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px auto', fontSize: '28px', border: b.story ? `3px solid ${accentColor}` : 'none' }}>👤</div>}
                        <div style={{ fontSize: '14px', fontWeight: 'bold', color: darkMode ? 'white' : '#0f172a' }}>{b.name}</div>
                      </div>
                    ))}
                  </div>
                  {bookingData.barber && bookingShop.barbers?.find(b => b.name === bookingData.barber)?.story && (
                    <div style={{ background: activeCategory === 'hairsalon' ? 'rgba(236, 72, 153, 0.1)' : 'rgba(249, 115, 22, 0.1)', borderLeft: `4px solid ${accentColor}`, padding: '10px 15px', borderRadius: '0 8px 8px 0', marginBottom: '20px', color: darkMode ? 'white' : '#0f172a', fontStyle: 'italic', fontSize: '14px' }}>
                      <strong>{bookingData.barber} says:</strong> "{bookingShop.barbers?.find(b => b.name === bookingData.barber)?.story}"
                    </div>
                  )}
                </div>

                {bookingData.barber && (
                  <div style={{ marginBottom: '25px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '10px', color: darkMode ? 'white' : '#0f172a' }}>2. Select Service</label>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                     {bookingShop.barbers?.find(b => b.name === bookingData.barber)?.services?.map((svc, idx) => (
                        <div key={idx} onClick={() => setBookingData({ ...bookingData, service: svc.name, time: '' })} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', cursor: 'pointer', borderRadius: '12px', border: bookingData.service === svc.name ? `2px solid ${secondaryColor}` : (darkMode ? '1px solid #334155' : '1px solid #e2e8f0'), background: bookingData.service === svc.name ? (darkMode ? '#0f172a' : (activeCategory === 'hairsalon' ? '#fdf2f8' : '#f8fafc')) : (darkMode ? '#1e293b' : 'white') }}>
                          <div><strong style={{ display: 'block', fontSize: '15px', color: darkMode ? 'white' : '#0f172a', marginBottom: '4px' }}>{svc.name}</strong><span style={{ fontSize: '13px', color: '#64748b' }}>⏱️ {svc.duration}</span></div>
                          <strong style={{ fontSize: '16px', color: '#059669' }}>{svc.price}</strong>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {bookingData.service && (
                  <div style={{ background: darkMode ? '#0f172a' : '#f8fafc', padding: '20px', borderRadius: '16px', border: darkMode ? '1px solid #334155' : '1px solid #e2e8f0' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '10px', color: darkMode ? 'white' : '#0f172a' }}>3. Date & Time</label>
                    <input type="date" value={bookingData.date} onChange={(e) => setBookingData({...bookingData, date: e.target.value, time: ''})} required style={{ width: '100%', padding: '12px', borderRadius: '10px', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1', marginBottom: '15px', boxSizing: 'border-box', background: darkMode ? '#1e293b' : 'white', color: darkMode ? 'white' : 'black', colorScheme: darkMode ? 'dark' : 'light' }} />

                    {bookingData.date && (
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: '10px', maxHeight: '180px', overflowY: 'auto', paddingRight: '5px' }}>
                        {availableSlots.length === 0 ? <p style={{ gridColumn: '1 / -1', color: '#ef4444', fontSize: '14px', margin: 0 }}>No availability for this duration.</p> : availableSlots.map(slot => (
                          <button key={slot} type="button" onClick={(e) => { e.preventDefault(); setBookingData({...bookingData, time: slot}); }} style={{ padding: '10px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', border: bookingData.time === slot ? `2px solid ${secondaryColor}` : (darkMode ? '1px solid #334155' : '1px solid #cbd5e1'), background: bookingData.time === slot ? secondaryColor : (darkMode ? '#1e293b' : 'white'), color: bookingData.time === slot ? 'white' : (darkMode ? 'white' : '#0f172a') }}>{slot}</button>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <button type="submit" className="submit-auth-btn" style={{ width: '100%', marginTop: '25px', padding: '16px', fontSize: '16px', background: secondaryColor }} disabled={!bookingData.time}>
                  {bookingData.time ? `Confirm Booking for ${bookingData.time}` : 'Select a time to continue'}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* LOGIN MODAL */}
        {isLoginModalOpen && (
          <div className="login-modal-overlay" onClick={() => setIsLoginModalOpen(false)}>
            <div className="login-modal-content" onClick={(e) => e.stopPropagation()} style={{background: darkMode ? '#1e293b' : 'white'}}>
              <button className="modal-close-btn" onClick={() => setIsLoginModalOpen(false)} style={{color: darkMode ? 'white' : 'black'}}>✕</button>

              {!selectedRole ? (
                <div className="modal-view-container" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
  <div className="portal-header">
    <h2 style={{color: darkMode ? 'white' : '#0f172a'}}>{t.joinPlatform}</h2>
    <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>{t.selectAccount}</p>
  </div>
        <div className="portal-grid">
          <div className="portal-card client" onClick={() => setSelectedRole('Client')} style={{background: darkMode ? '#0f172a' : 'white', borderColor: darkMode ? '#334155' : '#e2e8f0'}}>
            <div className="portal-icon">👤</div>
            <h3 style={{color: darkMode ? 'white' : '#0f172a'}}>{t.iamClient}</h3>
            <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>{t.clientDesc}</p>
            <button className="portal-login-btn">{t.continueClient}</button>
          </div>
          
          <div className="portal-card partner" onClick={() => setSelectedRole('Partner')} style={{background: darkMode ? '#0f172a' : 'white', borderColor: darkMode ? '#334155' : '#e2e8f0'}}>
            <div className="portal-icon">🏢</div>
            <h3 style={{color: darkMode ? 'white' : '#0f172a'}}>{t.iamPartner}</h3>
            <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>{t.partnerDesc}</p>
            <button className="portal-login-btn">{t.continuePartner}</button>
          </div>
          
          <div className="portal-card staff" onClick={() => setSelectedRole('Staff')} style={{background: darkMode ? '#0f172a' : 'white', borderColor: darkMode ? '#334155' : '#e2e8f0'}}>
            <div className="portal-icon">✂️</div>
            <h3 style={{color: darkMode ? 'white' : '#0f172a'}}>{t.iamStaff}</h3>
            <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>{t.staffDesc}</p>
            <button className="portal-login-btn">{t.continueStaff}</button>
          </div>
        </div>
      </div>
              ) : (
                <div className="modal-form-container">
                  <button className="back-to-roles-btn" onClick={() => { setSelectedRole(null); setAuthMode('login'); }}>← Back</button>
                  <h2 style={{color: darkMode ? 'white' : '#0f172a'}}>{selectedRole} {authMode === 'login' ? 'Login' : 'Registration'}</h2>
                  <div id="recaptcha-container"></div>

                <form className="auth-form" onSubmit={handleAuthSubmit}>
                    {authMode === 'register' && selectedRole !== 'Staff' && (
                      <div className="input-group"><label style={{color: darkMode ? '#cbd5e1' : '#0f172a'}}>Full Name</label><input type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required style={{background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1'}}/></div>
                    )}
                    {authMode === 'register' && selectedRole === 'Staff' && (
                      <>
                        <div className="input-group"><label style={{color: darkMode ? '#cbd5e1' : '#0f172a'}}>Location Invite Code</label><input type="text" value={inviteCode} onChange={(e) => verifyInviteCode(e.target.value)} required placeholder="Paste code here..." style={{background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1'}}/></div>
                        <div className="input-group"><label style={{color: darkMode ? '#cbd5e1' : '#0f172a'}}>Select Your Profile</label>
                          <select value={fullName} onChange={(e) => setFullName(e.target.value)} required disabled={shopBarbers.length === 0} style={{padding: '14px', borderRadius: '12px', background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1'}}>
                            <option value="">{isVerifyingCode ? 'Verifying...' : 'Select your name...'}</option>
                            {shopBarbers.map(b => <option key={b.id} value={b.name}>{b.name}</option>)}
                          </select>
                        </div>
                      </>
                    )}
                    <div className="input-group"><label style={{color: darkMode ? '#cbd5e1' : '#0f172a'}}>Email</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1'}}/></div>
                    {authMode === 'register' && (
  <div className="input-group">
    <label style={{color: darkMode ? '#cbd5e1' : '#0f172a'}}>Phone Number</label>
    <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required style={{background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1'}}/>
  </div>
)}<div className="input-group">
                      <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <label style={{color: darkMode ? '#cbd5e1' : '#0f172a'}}>Password</label>
                        {authMode === 'login' && <span style={{fontSize: '12px', color: '#3b82f6', cursor: 'pointer', fontWeight: 'bold'}} onClick={handleForgotPassword}>Forgot Password?</span>}
                      </div>
                      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{background: darkMode ? '#0f172a' : 'white', color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1'}}/>
                    </div>
                    
                    <button type="submit" className={`submit-auth-btn ${selectedRole.toLowerCase()}`}>{authMode === 'login' ? 'Sign In' : 'Create Account'}</button>
                    
                    <div style={{textAlign: 'center', margin: '15px 0', color: '#64748b', fontSize: '14px', fontWeight: 'bold'}}>OR</div>
                    
                    <button type="button" onClick={handleGoogleSignIn} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', background: darkMode ? '#0f172a' : 'white', border: darkMode ? '1px solid #334155' : '1px solid #cbd5e1', padding: '12px', borderRadius: '12px', cursor: 'pointer', fontWeight: 'bold', color: darkMode ? 'white' : '#0f172a', transition: '0.2s', width: '100%'}}>
                      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" style={{width: '20px'}}/>
                      Continue with Google
                    </button>
                  </form>
                  <div className="auth-footer">
                    {authMode === 'login' ? <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>Don't have an account? <span onClick={() => setAuthMode('register')}>Sign up</span></p> : <p style={{color: darkMode ? '#94a3b8' : '#64748b'}}>Already have an account? <span onClick={() => setAuthMode('login')}>Log in</span></p>}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* PREMIUM ENHANCED FOOTER */}
        <footer style={{ background: '#0f172a', color: '#cbd5e1', paddingTop: '60px', paddingBottom: '30px', marginTop: 'auto', borderTop: `4px solid ${secondaryColor}` }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                <div style={{ background: gradientPrimary, width: '35px', height: '35px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>⚡</div>
                <h2 style={{ color: 'white', margin: 0, fontSize: '22px', textTransform: 'uppercase', letterSpacing: '-1px' }}>Book<span style={{ color: accentColor }}>MyStyle</span></h2>
              </div>
              <p style={{ margin: 0, fontSize: '14px', color: '#94a3b8', lineHeight: '1.6' }}>The premier destination to discover top-rated professionals, book appointments instantly, and manage your schedule effortlessly.</p>
              <p style={{ marginTop: '15px', fontSize: '15px', color: '#3b82f6', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}>
                📸 Instagram: <a href="https://instagram.com/book_my_style101" target="_blank" rel="noreferrer" style={{ color: '#3b82f6', textDecoration: 'none' }}>@book_my_style101</a>
              </p>
            </div>
            <div>
              <h3 style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>{t.forClients}</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
                <li style={{ cursor: 'pointer' }}>{t.searchLocations}</li><li style={{ cursor: 'pointer' }}>{t.howItWorksTop}</li><li style={{ cursor: 'pointer' }}>{t.leaveReview}</li><li style={{ cursor: 'pointer' }}>{t.supportCenter}</li>
              </ul>
            </div>
            <div>
              <h3 style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>{t.forPartners}</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
                <li style={{ cursor: 'pointer' }}>{t.registerShop}</li><li style={{ cursor: 'pointer' }}>{t.pricingPlans}</li><li style={{ cursor: 'pointer' }}>{t.partnerDashboard}</li><li style={{ cursor: 'pointer' }}>{t.staffManagement}</li>
              </ul>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Home;